/* eslint-disable unicorn/filename-case */
import React, { useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { IntlContext, useTranslator } from '@jutro/locale';
import styles from './WMICPendingPaymentCancellation.module.scss';
import messages from './WMICPendingPaymentCancellation.messages';

const WMICPendingPaymentCancellationError = (props) => {
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const {
        payment
    } = props;

    const paymentDate = intl.formatDate(new Date(payment?.draftDate), { year: 'numeric', month: '2-digit', day: '2-digit' });

    return (
        <Fragment>
            <p aria-hidden className={styles['wmic-pending-payment-paragraph']}>
                {translator(messages.AnErrorOccurredWhileProcessingYourRequest)}
            </p>
            <p className="sr-only">
                {
                    translator(messages.AnErrorOccurredWhileProcessingYourRequestAria, {
                        eventDate: paymentDate,
                        amount: payment?.transactionAmount?.amount
                    })
                }
            </p>
            <p aria-hidden className={styles['wmic-pending-payment-paragraph']}>
                <strong>
                    {paymentDate}
                </strong>
                <br />
                { translator(messages.OneTimeBankWithdrawal) }
                <br />
                { translator(messages.Amount) }
                <CurrencyField
                    id={`currencyAmountPendingPayment${payment?.processID}`}
                    value={payment?.transactionAmount}
                    dataType="object"
                    readOnly
                    hideLabel
                    className={styles['wmic-pending-payment-value']}
                />
            </p>
        </Fragment>
    );
};

WMICPendingPaymentCancellationError.propTypes = {
    payment: PropTypes.bool.isRequired
};

export default WMICPendingPaymentCancellationError;
